import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';
import { siteCopy } from '../../content/siteCopy';

const Slider = {
  loop: true,
  margin: 10,
  breakpoints: {
    0: { slidesPerView: 1 },
    740: { slidesPerView: 2 },
    1000: { slidesPerView: 4 },
  },
};

const Text = () => {
  const labels = siteCopy.focusedTools.map((tool) => tool.label);

  return (
    <>
      <div
        className="text_list_section tls_aboutpage row_am"
        data-aos="fade-in"
        data-aos-duration={1500}
      >
        <div className="container">
          <span className="title_badge down_fix">{siteCopy.aboutUs.tickerBadge}</span>
        </div>
        <div className="slider_block">
          <Swiper
            className="mySwiper"
            id="text_list_flow"
            slidesPerView={4}
            spaceBetween={30}
            modules={[Autoplay]}
            autoplay
            {...Slider}
          >
            {labels.map((label) => (
              <SwiperSlide className="item" key={label}>
                <div className="text_block">
                  <span>{label}</span>
                  <span className="mark_star">•</span>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </>
  );
};

export default Text;
